import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, mergeProps as _mergeProps, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["aria-labelledby"]
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = ["id"]
const _hoisted_4 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_5 = { class: "treatment-record-history-list" }
const _hoisted_6 = { class: "item-header-date" }
const _hoisted_7 = { class: "item-contents-list" }
const _hoisted_8 = { class: "row-top" }
const _hoisted_9 = { class: "row-treatment-name" }
const _hoisted_10 = {
  key: 0,
  class: "row-new-treatment"
}
const _hoisted_11 = { class: "row-treatment-detail" }
const _hoisted_12 = { class: "row-disease-name" }
const _hoisted_13 = {
  key: 0,
  class: "row-change-status"
}
const _hoisted_14 = { class: "row-change-status-text" }
const _hoisted_15 = {
  key: 1,
  class: "row-change-effect"
}
const _hoisted_16 = { class: "row-change-effect-text" }
const _hoisted_17 = { class: "row-change-effect-detail" }
const _hoisted_18 = { class: "row-change-effect-detail-label" }
const _hoisted_19 = { class: "row-change-effect-detail-label" }
const _hoisted_20 = {
  key: 2,
  class: "row-effect"
}
const _hoisted_21 = { class: "row-effect-text" }
const _hoisted_22 = { class: "row-effect-label" }
const _hoisted_23 = {
  key: 3,
  class: "row-change-reason"
}
const _hoisted_24 = { class: "row-change-reason-text" }
const _hoisted_25 = {
  key: 0,
  class: "row-change-reason-button-wrapper"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = {
  key: 0,
  class: "treatment-record-history-list no-start-date"
}
const _hoisted_29 = { class: "treatment-record-history-item" }
const _hoisted_30 = { class: "item-header-date" }
const _hoisted_31 = { class: "item-contents-list" }
const _hoisted_32 = { class: "row-top" }
const _hoisted_33 = { class: "row-treatment-name" }
const _hoisted_34 = { class: "row-new-treatment" }
const _hoisted_35 = {
  key: 0,
  class: "row-treatment-detail"
}
const _hoisted_36 = { class: "row-disease-name" }
const _hoisted_37 = {
  key: 1,
  class: "row-effect"
}
const _hoisted_38 = { class: "row-effect-text" }
const _hoisted_39 = { class: "row-effect-label" }
const _hoisted_40 = { class: "modal-footer" }
const _hoisted_41 = { class: "modal-footer-buttons" }

import dayjs from "dayjs";
import "dayjs/locale/ja";
import utc from "dayjs/plugin/utc";

import {
  onMounted,
  nextTick,
  ref,
  reactive,
  toRefs,
} from "vue";
import { processing, processend } from "@/utils/view";
import { _$t } from "@/utils/i18n";
import { TreatmentStatus } from "@/models/myRecord/clinicNote/types";

import ErrorDialog from "@/views/base/CommonMessage.vue";
import { Treatment } from "@/models/myRecord/treatment";

// 日付のローカライズ
type TimelineData = {
  burden_of_medicine?: string;
  created_id: number;
  disease_code: string;
  history_date_kubun: number;
  modified_id: number;
  previous_effect_id: number;
  resume_date: string;
  sub_number: number;
  treatment_detail: string;
  treatment_effect_option_id: number;
  treatment_option_id: number;
  treatment_start_date: string;
  treatment_status_option_id: number;
  user_id: number;
  user_treatment_id: number;
  is_new_record: boolean;
};

type Option = {
  option_id: number;
  value: number;
  kubun: string;
  display_name: string;
};

// ---- props ----------------------------------------
const REASON_TEXT_COLLAPSE_HEIGHT = 55;
// コンポーネントID
const componentId = "healthcaredata02-02-c-modal";

// モーダルタイトル

export default /*@__PURE__*/_defineComponent({
  __name: 'TreatmentHistory',
  props: {
    diseases: {},
    limitDate: {}
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {

dayjs.locale("ja");
dayjs.extend(utc);

const props = __props;

const { diseases } = toRefs(props);

// ---- Constants & Variables ------------------------------
const timelineTreatments = ref<{ [key: string]: TimelineData[] }>();
const pendingTreatments = ref<TimelineData[]>([]);
const effectOptions = ref<Option[]>([]);
const treatmentOptions = ref<Option[]>([]);
const statusOptions = ref<Option[]>([]);
const isInitialized = ref(false);
const sessionErr = ref(false);
const expandedReasons = reactive(new Set<string>());
const reasonDetailRefs = reactive<Record<string, any>>({});
const showToggleButtons = reactive<Record<string, boolean>>({});
const title = _$t("treatment_history_modal_title");
const treatment = new Treatment();

const emit = __emit;

// --- Error Dialog -------------------------------------------
let errorDialogSet = reactive({
  show: false,
  okButtonHide: true,
  safe: false,
  message: "",
  open: (message: string): void => {
    processing();
    errorDialogSet.message = message;
    errorDialogSet.show = true;
  },
  close: (): void => {
    processend();
    errorDialogSet.show = false;
    errorDialogSet.message = "";
    if (sessionErr.value) {
      window.location.replace("/cms/login");
    }
  },
});

// --- Functions -------------------------------------------

// --- Event handlers --------------------------------------------

// 閉じるボタン押下時処理
function onClose() {
  emit("close");
}

function getStatusValue(statusOptionId: number): number {
  const option = statusOptions.value.find(
    (s) => s.option_id === statusOptionId
  );
  return option?.value ?? 0;
}

function getReasonKey(date: string, index: number): string {
  return `${date}-${index}`;
}

function getDiseaseName(diseaseCode: string | null): string {
  return diseaseCode
    ? `${
        diseases.value.find((d) => d.id === diseaseCode)?.name || diseaseCode
    }${_$t("treatment_label_disease_treatment")}`
    : _$t("treatment_select_option_no_diseases");
}

function checkReasonTextHeight(key: string): boolean {
  const element = reasonDetailRefs[key];
  if (!element) return false;

  const shouldShow = element.scrollHeight > REASON_TEXT_COLLAPSE_HEIGHT;
  showToggleButtons[key] = shouldShow;

  if (!shouldShow) {
    expandedReasons.delete(key);
  }
  return shouldShow;
}

function toggleReasonExpand(key: string): void {
  if (expandedReasons.has(key)) {
    expandedReasons.delete(key);
    return;
  }
  expandedReasons.add(key);
}

function updateReasonToggleButtons(): void {
  Object.keys(reasonDetailRefs).forEach((key) => {
    checkReasonTextHeight(key);
  });
}

const fetchTreatmentHistory = async () => {
  const [_model, response, err] = await treatment.getHistory(props.limitDate);
  if (err) {
    const decodedMessage = decodeURIComponent(
      err.error?.response?.data?.message
    );
    const status = err.error?.response?.status;
    if (status === 408) {
      // セッションエラー
      sessionErr.value = true;
    }
    errorDialogSet.open(decodedMessage);
    return;
  }

  pendingTreatments.value = response.data.pending;
  timelineTreatments.value = response.data.timeline;
  effectOptions.value = response.data.effectOptions;
  treatmentOptions.value = response.data.treatmentOptions;
  statusOptions.value = response.data.statusOptions;
};

// --- Vue lifecycle --------------------------------------------
onMounted(async () => {
  // 初期設定
  await fetchTreatmentHistory();
  isInitialized.value = true;
  await nextTick();
  updateReasonToggleButtons();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", { id: componentId }, [
      _createElementVNode("body", null, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "modal-overlay" }, null, -1)),
        _createElementVNode("div", {
          class: "modal modal-treatment-record-history",
          role: "dialog",
          "aria-modal": "true",
          "aria-labelledby": `${componentId}-title`
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: "modal-header-title",
              id: `${componentId}-title`
            }, _toDisplayString(_unref(title)), 9, _hoisted_3),
            _createElementVNode("button", {
              class: "modal-close",
              "aria-label": "Close modal",
              onClick: onClose
            }, _cache[0] || (_cache[0] = [
              _createElementVNode("img", { src: "/server/necs/images/close-btn.png" }, null, -1)
            ]))
          ]),
          (isInitialized.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("ul", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(timelineTreatments.value, (treatments, date) => {
                    return (_openBlock(), _createElementBlock("li", {
                      class: "treatment-record-history-item",
                      key: date
                    }, [
                      _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(dayjs)(date).format("YYYY年M月D日")), 1),
                      _createElementVNode("ul", _hoisted_7, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(treatments, (treatment, i) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: _normalizeClass(["item-contents-row", {
                    'new-treatment':
                      treatment.is_new_record || treatment.sub_number === 1,
                  }]),
                            key: i
                          }, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("div", _hoisted_9, [
                                _cache[1] || (_cache[1] = _createElementVNode("img", {
                                  src: "/server/necs/images/icon_treatment_name.svg",
                                  alt: "治療名"
                                }, null, -1)),
                                _createElementVNode("span", null, _toDisplayString(treatmentOptions.value.find(
                          (t) => t.option_id === treatment.treatment_option_id
                        )?.display_name), 1)
                              ]),
                              (treatment.sub_number === 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t("treatment_history_modal_label_new")), 1))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("p", _hoisted_11, _toDisplayString(treatment.treatment_detail), 1),
                            _createElementVNode("p", _hoisted_12, _toDisplayString(getDiseaseName(treatment.disease_code)), 1),
                            (treatment.treatment_status_option_id)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                  _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t("treatment_history_modal_label_status_change")), 1),
                                  _createElementVNode("span", {
                                    class: _normalizeClass(["row-change-status-label", {
                        finish:
                          getStatusValue(
                            treatment.treatment_status_option_id
                          ) === _unref(TreatmentStatus).Finish,
                        suspend:
                          getStatusValue(
                            treatment.treatment_status_option_id
                          ) === _unref(TreatmentStatus).Suspend,
                        resume:
                          getStatusValue(
                            treatment.treatment_status_option_id
                          ) === _unref(TreatmentStatus).Resume,
                      }])
                                  }, _toDisplayString(statusOptions.value.find(
                          (s) =>
                            s.option_id === treatment.treatment_status_option_id
                        )?.display_name), 3)
                                ]))
                              : _createCommentVNode("", true),
                            (
                      treatment.previous_effect_id &&
                      treatment.treatment_effect_option_id
                    )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$t("treatment_history_modal_label_effect_change")), 1),
                                  _createElementVNode("div", _hoisted_17, [
                                    _createElementVNode("span", _hoisted_18, _toDisplayString(effectOptions.value.find(
                          (e) => e.option_id === treatment.previous_effect_id
                        )?.display_name), 1),
                                    _cache[2] || (_cache[2] = _createElementVNode("img", {
                                      src: "/server/necs/images/icon_arrow_right_straight.svg",
                                      alt: ""
                                    }, null, -1)),
                                    _createElementVNode("span", _hoisted_19, _toDisplayString(effectOptions.value.find(
                          (e) =>
                            e.option_id === treatment.treatment_effect_option_id
                        )?.display_name), 1)
                                  ])
                                ]))
                              : (treatment.treatment_effect_option_id)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                    _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.$t("treatment_history_modal_label_effect")), 1),
                                    _createElementVNode("span", _hoisted_22, _toDisplayString(effectOptions.value.find(
                        (e) =>
                          e.option_id === treatment.treatment_effect_option_id
                      )?.display_name), 1)
                                  ]))
                                : _createCommentVNode("", true),
                            (treatment.burden_of_medicine)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                  _createElementVNode("p", _hoisted_24, _toDisplayString(_ctx.$t("treatment_history_modal_label_change_reason")), 1),
                                  _createElementVNode("p", {
                                    class: _normalizeClass(["row-change-reason-detail", {
                        expanded: expandedReasons.has(
                          getReasonKey(String(date), i)
                        ),
                      }]),
                                    ref_for: true,
                                    ref: 
                        (el) =>
                          (reasonDetailRefs[getReasonKey(String(date), i)] = el)
                      
                                  }, _toDisplayString(treatment.burden_of_medicine), 3),
                                  (showToggleButtons[getReasonKey(String(date), i)])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                        _createElementVNode("button", {
                                          class: _normalizeClass(["row-change-reason-show", 
                          expandedReasons.has(getReasonKey(String(date), i))
                            ? 'hidden'
                            : 'active'
                        ]),
                                          onClick: ($event: any) => (
                          toggleReasonExpand(getReasonKey(String(date), i))
                        )
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_history_modal_label_display_all")), 1),
                                          _cache[3] || (_cache[3] = _createElementVNode("img", {
                                            src: "/server/necs/images/arrow-right_icon.png",
                                            alt: ""
                                          }, null, -1))
                                        ], 10, _hoisted_26),
                                        _createElementVNode("button", {
                                          class: _normalizeClass(["row-change-reason-hide", 
                          expandedReasons.has(getReasonKey(String(date), i))
                            ? 'active'
                            : 'hidden'
                        ]),
                                          onClick: ($event: any) => (
                          toggleReasonExpand(getReasonKey(String(date), i))
                        )
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.$t("treatment_history_modal_label_close")), 1),
                                          _cache[4] || (_cache[4] = _createElementVNode("img", {
                                            src: "/server/necs/images/arrow-right_icon.png",
                                            alt: ""
                                          }, null, -1))
                                        ], 10, _hoisted_27)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : _createCommentVNode("", true)
                          ], 2))
                        }), 128))
                      ])
                    ]))
                  }), 128))
                ]),
                (pendingTreatments.value.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_28, [
                      _createElementVNode("li", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("treatment_history_modal_label_not_started")), 1),
                        _createElementVNode("ul", _hoisted_31, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pendingTreatments.value, (treatment, i) => {
                            return (_openBlock(), _createElementBlock("li", {
                              class: "item-contents-row new-treatment",
                              key: i
                            }, [
                              _createElementVNode("div", _hoisted_32, [
                                _createElementVNode("div", _hoisted_33, [
                                  _cache[5] || (_cache[5] = _createElementVNode("img", {
                                    src: "/server/necs/images/icon_treatment_name.svg",
                                    alt: "治療名"
                                  }, null, -1)),
                                  _createElementVNode("span", null, _toDisplayString(treatmentOptions.value.find(
                          (t) => t.option_id === treatment.treatment_option_id
                        )?.display_name), 1)
                                ]),
                                _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.$t("treatment_history_modal_label_new")), 1)
                              ]),
                              (treatment.treatment_detail)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_35, _toDisplayString(treatment.treatment_detail), 1))
                                : _createCommentVNode("", true),
                              _createElementVNode("p", _hoisted_36, _toDisplayString(getDiseaseName(treatment.disease_code)), 1),
                              (treatment.treatment_effect_option_id)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                                    _createElementVNode("p", _hoisted_38, _toDisplayString(_ctx.$t("treatment_history_modal_label_effect")), 1),
                                    _createElementVNode("span", _hoisted_39, _toDisplayString(effectOptions.value.find(
                        (e) =>
                          e.option_id === treatment.treatment_effect_option_id
                      )?.display_name), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_40, [
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("button", {
                class: "modal-ok",
                onClick: onClose
              }, _toDisplayString(_ctx.$t("treatment_history_modal_button_close")), 1)
            ])
          ])
        ], 8, _hoisted_1)
      ])
    ]),
    (_unref(errorDialogSet).show)
      ? (_openBlock(), _createBlock(ErrorDialog, _mergeProps({ key: 0 }, _unref(errorDialogSet), {
          onOk: _unref(errorDialogSet).close,
          onCancel: _unref(errorDialogSet).close
        }), null, 16, ["onOk", "onCancel"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})